let code = 'ot';
let codeAPI = 'ot';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};